import { FacebookHero } from "../components/home/FacebookHero";
import { Example } from "../components/home/Example";


export function FacebookLandingPage() {

  return (
    <>
      <div>
        <FacebookHero />
        <Example />
      </div>
    </>
  );


}